module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige13-e113640f9322afb54945e4cd64e91678.jpg";